<template>
  <div class="box">
    <el-card shadow="never" class="box-card-class c1">
      <el-row type="flex" style="justify-content: space-between;align-items: center;flex-wrap: wrap">
        <el-col :span="6">
          <div style="letter-spacing: 2px;font-size: 20px;color: #0F172A;font-weight: 600">运输看板</div>
          <div style="font-size: 14px;color: #A8AEB9">Atualizado(Horário de Brasília)</div>
        </el-col>
        <el-col :span="16">
          <el-col :span="12" style="text-align: right; padding-right: 20px;box-sizing: border-box">
            <div style="display: inline-block; text-align: center">
              <el-radio-group v-model="dateRadio" size="mini" class="custom-radio-group">
                <el-radio-button label="yesterday">{{ $t('collectionCenter.yesterday') }}</el-radio-button>
                <el-radio-button label="today">{{ $t('newOrder.today') }}</el-radio-button>
                <el-radio-button label="month">{{ $t('newOrder.thisMonth') }}</el-radio-button>
                <el-radio-button label="lastMonth">{{ $t('collectionCenter.lastMonth') }}</el-radio-button>
              </el-radio-group>
              <br>
              <el-date-picker
                v-model="timeVal"
                type="daterange"
                value-format="yyyy-MM-dd"
                :end-placeholder="$t('collectionCenter.EndTime')"
                range-separator="~"
                :start-placeholder="$t('collectionCenter.StartTime')"
                size="mini" :clearable="false"
                class="dateClass"
                @change="dateChange"
              />
            </div>
          </el-col>
          <el-col :span="12" class="regionSteteClass">
            <el-col :span="8" class="dividerClass">
              <div class="searchClass">大区 Área</div>
              <ElSelectV2
                v-model="queryForm.params.areaNameList"
                :options="regionList"
                :placeholder="$t('placeOrder.pleaseChoose')"
                clearable filterable multiple
                collapse-tags
                style="width: 90%" size="mini"
                popper-class="SelectV2_popper"
                @change="changeRegion"
              />
            </el-col>
            <el-col :span="8" class="dividerClass">
              <div class="searchClass">州 Estado</div>
              <ElSelectV2
                v-model="queryForm.params.stateList"
                :options="stateList"
                :placeholder="$t('placeOrder.pleaseChoose')"
                clearable filterable multiple
                collapse-tags
                style="width: 90%" size="mini"
                popper-class="SelectV2_popper"
                @change="changeState"
              />
            </el-col>
            <el-col :span="8">
              <div class="searchClass">转运中心 HUB</div>
              <ElSelectV2
                v-model="queryForm.params.departmentList"
                :options="transitCenterOptions"
                :placeholder="$t('placeOrder.pleaseChoose')"
                clearable filterable multiple
                collapse-tags
                style="width: 90%" size="mini"
                popper-class="SelectV2_popper"
              />
            </el-col>
            <div
              class="el-icon-search searchBtn"
              @click="search"
            />
          </el-col>
        </el-col>
      </el-row>
      <div v-show="updateTime" class="update_time_class">数据更新时间(北京时间)：{{ updateTime }}</div>
    </el-card>
    <el-card shadow="never" class="box-card-class c2">
      <el-tabs v-model="queryForm.params.dataType" @tab-click="handleClick">
        <el-tab-pane label="揽收运输 Coleta e transp" name="揽收运输" />
        <el-tab-pane label="干线运输 Transporte de linha" name="干线运输" />
        <el-tab-pane label="支线运输 Transporte Alimentador" name="支线运输" />
      </el-tabs>
    </el-card>
    <el-card shadow="never" class="box-card-class">
      <span class="redClass">客户 Cliente</span>
      <el-select
        v-model="queryForm.params.customerNameList"
        filterable clearable multiple
        collapse-tags
        remote reserve-keyword
        :remote-method="getCustomerPage"
        :placeholder="$t('spareNumberPoo.Only20AreDisplayed')"
        @clear="getCustomerPage('')"
      >
        <el-option
          v-for="(item, ind) in customerList"
          :key="ind"
          :label="item.customerAlias + '(' + item.username + ')'"
          :value="item.username"
        />
      </el-select>
    </el-card>
    <el-card shadow="never" class="box-card-class c4">
      <el-row>
        <el-col style="border-right: 1px solid #E6EAED;box-sizing: border-box;width: 60%;position:relative">
          <i class="el-icon-upload2 uploadClass" @click="exportThis(1)" />
          <div class="card-title-class">装卸车辆数据监控 Monitor Veículos</div>
          <div class="data-monitoring-container">
            <div
              v-for="(row, rowIndex) in groupedVehicleDataList"
              :key="rowIndex"
              class="data-card-wrapper"
            >
              <el-col
                v-for="(item, index) in row"
                :key="index" class="data-card"
              >
                <div class="corner-decoration">
                  <div :class="['corner-rectangle', `style-${rowIndex * 3 + index + 1}`]" />
                  <div :class="['corner-square', `style-${rowIndex * 3 + index + 1}`]" />
                  <i
                    v-if="index !== 2"
                    :class="['corner-icon', `style-${rowIndex * 3 + index + 1}`, 'el-icon-truck']"
                  />
                  <i
                    v-else
                    :class="['corner-icon', `style-${rowIndex * 3 + index + 1}`, 'el-icon-warning-outline']"
                  />
                </div>
                <div class="data-label">{{ item.label }}</div>
                <div class="data-value">{{ item.value }}</div>
              </el-col>
            </div>
          </div>
        </el-col>
        <el-col style="width: 40%;position:relative">
          <i class="el-icon-upload2 uploadClass" @click="exportThis(2)" />
          <div class="card-title-class">看板运输装载情况 Status de Carga</div>
          <div class="data-monitoring-container">
            <div
              v-for="(row, rowIndex) in groupedTransportDataList"
              :key="rowIndex"
              class="data-card-wrapper"
              :style="{ justifyContent: rowIndex === 1 ? 'flex-start' : 'space-between' }"
            >
              <el-col
                v-for="(item, index) in row"
                :key="index" class="data-card"
                :style="{ flex: rowIndex === 1 && index === 0 ? '0 0 calc(50% - 5px)' : '1' }"
              >
                <div class="corner-decoration">
                  <div :class="['corner-rectangle', 'style-11']" />
                  <div :class="['corner-square', 'style-22']" />
                  <i
                    :class="['corner-icon', `style-${rowIndex === 0 && index === 0 ? '33' : '44'}`, 'el-icon-truck']"
                  />
                </div>
                <div class="data-label">{{ item.label }}</div>
                <div class="data-value">{{ item.value }}</div>
              </el-col>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-row type="flex" style="justify-content: space-between;align-items: flex-start;gap: 10px">
      <el-col :span="12">
        <el-card shadow="never" class="box-card-class" style="position: relative">
          <i class="el-icon-upload2 uploadClass u3" @click="exportThis(3)" />
          <div class="card-title-class last">到车准点监控 Monitor de Chegada no Horário</div>
          <div class="arrival-monitoring-content">
            <div class="info-section">
              <span class="info-label left">{{ arrivalRate }}</span>
              <span class="info-detail">
                <span>到车准点率</span><br>
                <span>Taxa de Chegada no Horário</span>
              </span>
            </div>
            <el-table
              :data="arrivalTableData" border style="width: 100%"
              class="arrival-table" max-height="600"
            >
              <el-table-column prop="dimFlow" label="来向Fluxo" />
              <el-table-column prop="exceptArrivalTime" label="预计到车时间Prev. Chegada" />
              <el-table-column prop="actualArrivalTime" label="实际到车时间Chegada Real" />
              <el-table-column prop="timeoutDuration" label="超时时长Duração Estouro(h)">
                <template slot-scope="scope">
                  <span :style="scope.row.timeoutDuration > 0 ? 'color: red' : 'color: green'">
                    {{ scope.row.timeoutDuration ? scope.row.timeoutDuration + 'H' : '--' }}
                  </span>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              :current-page="ArrivalForm.pageNumber"
              :page-size="ArrivalForm.pageSize"
              :page-sizes="[10, 20, 50, 100]"
              :total="ArrivalForm.total"
              background
              layout="total, sizes, prev, pager, next, jumper"
              style="margin: 10px 0; float: right"
              @size-change="handleArrivalMonitor1"
              @current-change="handleArrivalMonitor"
            />
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card shadow="never" class="box-card-class" style="position: relative">
          <i class="el-icon-upload2 uploadClass u4" @click="exportThis(4)" />
          <div class="card-title-class last">发车准点监控 Monitor Partida no Horário</div>
          <div class="arrival-monitoring-content">
            <div class="info-section">
              <span class="info-label right">{{ departRate }}</span>
              <span class="info-detail">
                <span>发车及时率</span><br>
                <span>Taxa Partida no Horário</span>
              </span>
            </div>
            <el-table
              :data="departTableData" border style="width: 100%"
              class="arrival-table" max-height="600"
            >
              <el-table-column prop="dimFlow" label="流向Fluxo" />
              <el-table-column prop="exceptDepartTime" label="预计发车时间Prev. Partida" />
              <el-table-column prop="actualDepartTime" label="实际发车时间Partida Real" />
              <el-table-column prop="timeoutDuration" label="超时时长Duração Estouro(h)">
                <template slot-scope="scope">
                  <span :style="scope.row.timeoutDuration > 0 ? 'color: red' : 'color: green'">
                    {{ scope.row.timeoutDuration ? scope.row.timeoutDuration + 'H' : '--' }}
                  </span>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              :current-page="departForm.pageNumber"
              :page-size="departForm.pageSize"
              :page-sizes="[10, 20, 50, 100]"
              :total="departForm.total"
              background
              layout="total, sizes, prev, pager, next, jumper"
              style="margin: 10px 0; float: right"
              @size-change="handleDepartMonitor1"
              @current-change="handleDepartMonitor"
            />
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  regionQueryList,
  getLgAreaListData,
  dashboardChartData,
  dashboardExport
} from '@/api/orderApi';
import { apiGetCustomerPage } from '@/api/finance/contasDeClientes';
import {
  lmLossResponsibilityGetTransferCenterOptions
} from '@/api/definiteResponsibilityAndPenalty';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { goResourceTaskList } from '@/utils/goExportList';
dayjs.extend(utc);
dayjs.extend(timezone);
import ElSelectV2 from 'el-select-v2';

export default {
  name: 'VehicleDataMonitoring',
  components: {
    ElSelectV2
  },
  data() {
    return {
      updateTime: '',
      dateRadio: 'yesterday',
      timeVal: '',
      queryForm: {
        dashboardType: 'TRANSPORT_DASHBOARD', // 枚举类型
        chartType: '', // Type 值
        params: {
          startDate: '',
          endDate: '',
          areaNameList: [],
          departmentList: [],
          stateList: [],
          customerNameList: [],
          dataType: '揽收运输'
        }
      },
      ArrivalForm: {
        pageNumber: 1,
        pageSize: 10,
        total: 0
      },
      departForm: {
        pageNumber: 1,
        pageSize: 10,
        total: 0
      },
      regionList: [], // 数据量过多时，需要处理为虚拟下拉
      stateList: [], // 数据量过多时，需要处理为虚拟下拉
      transitCenterOptions: [], // 数据量过多时，需要处理为虚拟下拉
      customerList: [],
      vehicleDataList: [],
      transportDataList: [],
      arrivalRate: '0%',
      arrivalTableData: [],
      departRate: '0%',
      departTableData: []
    };
  },
  computed: {
    groupedVehicleDataList() {
      const grouped = [];
      const pageSize = 3;
      for (let i = 0; i < this.vehicleDataList.length; i += pageSize) {
        grouped.push(this.vehicleDataList.slice(i, i + pageSize));
      }
      return grouped;
    },
    groupedTransportDataList() {
      const grouped = [];
      const pageSize = 2;
      for (let i = 0; i < this.transportDataList.length; i += pageSize) {
        grouped.push(this.transportDataList.slice(i, i + pageSize));
      }
      return grouped;
    }
  },
  watch: {
    dateRadio(val) {
      this.changeTime(val);
    }
  },
  created() {
    this.timeVal = [
      dayjs().subtract(1, 'day').format('YYYY-MM-DD'),
      dayjs().subtract(1, 'day').format('YYYY-MM-DD')
    ];
    this.search();
    this.getRegion();
    this.getState();
    this.getDepartment();
    this.getCustomerPage('');
  },
  methods: {
    // 切换 揽收运输 / 干线运输 / 支线运输
    handleClick(val) {
      this.queryForm.params.dataType = val.name;
      this.search();
    },
    search() {
      this.queryForm.params.startDate = this.timeVal[0];
      this.queryForm.params.endDate = this.timeVal[1];
      this.ArrivalForm.pageNumber = 1;
      this.ArrivalForm.pageSize = 10;
      this.departForm.pageNumber = 1;
      this.departForm.pageSize = 10;
      this.handleLoaderMonitor(); // 装卸车辆数据监控
      this.handleLoaderSituation(); // 看板运输装载情况
      this.handleArrivalRate(); // 到车准点监控————百分数
      this.handleArrivalMonitor(); // 到车准点监控————表格
      this.handleDepartRate(); // 发车及时率————百分数
      this.handleDepartMonitor(); // 发车及时率————表格
      this.getUpdateTime();
    },
    // 更新时间
    getUpdateTime() {
      const queryForm = JSON.parse(JSON.stringify(this.queryForm));
      queryForm.chartType = 'updateTime';
      dashboardChartData(queryForm).then((res) => {
        if (res.code === 200) {
          this.updateTime = res.data.chartData;
        }
      });
    },
    // 装卸车辆数据监控
    handleLoaderMonitor() {
      const queryForm = JSON.parse(JSON.stringify(this.queryForm));
      queryForm.chartType = 'loaderMonitor';
      dashboardChartData(queryForm).then((res) => {
        if (res.code === 200) {
          this.vehicleDataList = [
            { label: '应装车票数Prev. Carga', value: res.data.chartData?.exceptLoadCnt || 0 },
            { label: '实际装车票数Carga Real', value: res.data.chartData?.actualLoadCnt || 0 },
            { label: '装车差异Dif. Carga', value: res.data.chartData?.loadDiffCnt || 0 },
            { label: '应卸车票数Prev. Descarga', value: res.data.chartData?.exceptUnloadCnt || 0 },
            { label: '实际卸车票数Descarga Real', value: res.data.chartData?.actualUnloadCnt || 0 },
            { label: '卸车差异Dif. Descarga', value: res.data.chartData?.unloadDiffCnt || 0 }
          ];
        }
      });
    },
    // 看板运输装载情况
    handleLoaderSituation() {
      const queryForm = JSON.parse(JSON.stringify(this.queryForm));
      queryForm.chartType = 'loaderSituation';
      dashboardChartData(queryForm).then((res) => {
        if (res.code === 200) {
          const avgLoadRate = res.data.chartData?.avgLoadRate || 0;
          this.transportDataList = [
            { label: '所用车辆Veículos Utilizados', value: res.data.chartData?.useVelCnt || 0 },
            { label: '总装载容量Capacidade Total', value: res.data.chartData?.totalVolume || 0 },
            { label: '平均装载率Média Carga', value: avgLoadRate ? (avgLoadRate * 100).toFixed(2) + '%' : '0.00%' }
          ];
        }
      });
    },
    // 到车准点率
    handleArrivalRate() {
      const queryForm = JSON.parse(JSON.stringify(this.queryForm));
      queryForm.chartType = 'arrivalRate';
      dashboardChartData(queryForm).then((res) => {
        if (res.code === 200) {
          const rateValue = Number(res.data.chartData.arrivalRate) * 100;
          this.arrivalRate = rateValue === 0 ? '0%' : rateValue.toFixed(2) + '%';
        }
      });
    },
    // 到车监控
    handleArrivalMonitor1(size) {
      this.ArrivalForm.pageNumber = 1;
      this.ArrivalForm.pageSize = size;
      this.handleArrivalMonitor(1);
    },
    handleArrivalMonitor(page = 1) {
      this.ArrivalForm.pageNumber = page;
      const queryForm = JSON.parse(JSON.stringify(this.queryForm));
      queryForm.chartType = 'arrivalMonitor';
      queryForm.pageNumber = this.ArrivalForm.pageNumber;
      queryForm.pageSize = this.ArrivalForm.pageSize;
      dashboardChartData(queryForm).then((res) => {
        if (res.code === 200) {
          this.arrivalTableData = res.data.chartData;
          this.ArrivalForm.total = res.data.statistics.total;
        }
      });
    },
    // 发车及时率
    handleDepartRate() {
      const queryForm = JSON.parse(JSON.stringify(this.queryForm));
      queryForm.chartType = 'departRate';
      dashboardChartData(queryForm).then((res) => {
        if (res.code === 200) {
          const rateValue = Number(res.data.chartData.departRate) * 100;
          this.departRate = rateValue === 0 ? '0%' : rateValue.toFixed(2) + '%';
        }
      });
    },
    // 发车监控
    handleDepartMonitor1(size) {
      this.departForm.pageNumber = 1;
      this.departForm.pageSize = size;
      this.handleDepartMonitor(1);
    },
    handleDepartMonitor(page = 1) {
      this.departForm.pageNumber = page;
      const queryForm = JSON.parse(JSON.stringify(this.queryForm));
      queryForm.chartType = 'departMonitor';
      queryForm.pageNumber = this.departForm.pageNumber;
      queryForm.pageSize = this.departForm.pageSize;
      dashboardChartData(queryForm).then((res) => {
        if (res.code === 200) {
          this.departTableData = res.data.chartData;
          this.departForm.total = res.data.statistics.total;
        }
      });
    },
    exportThis(type) {
      const queryForm = JSON.parse(JSON.stringify(this.queryForm));
      switch (type) {
        case 1:
          queryForm.chartType = 'loaderMonitor';
          break;
        case 2:
          queryForm.chartType = 'loaderSituation';
          break;
        case 3:
          queryForm.chartType = 'arrivalMonitor';
          queryForm.pageNumber = this.ArrivalForm.pageNumber;
          queryForm.pageSize = this.ArrivalForm.pageSize;
          break;
        default:
          queryForm.chartType = 'departMonitor';
          queryForm.pageNumber = this.departForm.pageNumber;
          queryForm.pageSize = this.departForm.pageSize;
          break;
      }
      dashboardExport(queryForm).then((res) => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    dateChange(val) {
      if (val && val.length > 0) {
        this.dateRadio = '';
        this.queryForm.params.startDate = val[0];
        this.queryForm.params.endDate = val[1];
      } else {
        this.queryForm.params.startDate = '';
        this.queryForm.params.endDate = '';
      }
    },
    changeTime(val) {
      // 时间段类型：yesterday/today/month/lastMonth
      const today = dayjs();
      switch (val) {
        case 'yesterday':
          this.timeVal = [
            today.subtract(1, 'day').format('YYYY-MM-DD'),
            today.subtract(1, 'day').format('YYYY-MM-DD')
          ];
          break;
        case 'today':
          this.timeVal = [today.format('YYYY-MM-DD'), today.format('YYYY-MM-DD')];
          break;
        case 'month':
          this.timeVal = [
            today.startOf('month').format('YYYY-MM-DD'),
            today.format('YYYY-MM-DD')
          ];
          break;
        case 'lastMonth':
          this.timeVal = [
            today.subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
            today.subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
          ];
          break;
      }
      this.queryForm.params.startDate = this.timeVal[0];
      this.queryForm.params.endDate = this.timeVal[1];
    },
    // 大区
    getRegion() {
      regionQueryList('').then((res) => {
        if (res.code === 200) {
          this.regionList = (res.data || []).map((item) => {
            return {
              value: item.zhName,
              label: item.zhName + '（' + item.puName + '）',
              ...item
            };
          });
        }
      });
    },
    changeRegion(val) {
      // 多选大区多选州
      this.queryForm.params.stateList = [];
      this.queryForm.params.departmentList = [];
      if (val && val.length > 0) {
        const allStates = [];
        val.forEach(regionId => {
          const selectedRegion = this.regionList.find(item => item.value === regionId);
          if (selectedRegion && Array.isArray(selectedRegion.states)) {
            // 将州列表添加到总列表中
            selectedRegion.sites.forEach(state => {
              // 避免重复添加
              if (!allStates.some(s => s.label === state.state)) {
                allStates.push({
                  id: state.id,
                  label: state.state
                });
              }
            });
          }
        });
        this.stateList = allStates.map((item) => {
          return {
            value: item.label,
            label: item.label
          };
        });
      } else {
        this.stateList = [];
        this.getState();
        this.transitCenterOptions = [];
        this.getDepartment();
      }
    },
    // 州
    getState() {
      const params = {
        level: 0,
        parentId: ''
      };
      getLgAreaListData(params, false).then((res) => {
        if (res.code === 200) {
          this.stateList = (res.data || []).map((item) => {
            return {
              value: item.nameEn,
              label: item.nameEn
            };
          });
        }
      });
    },
    changeState() {
      this.queryForm.params.departmentList = [];
      this.getDepartment();
    },
    // 转运中心
    getDepartment() {
      const param = {
        stateList: this.queryForm.params.stateList || []
      };
      lmLossResponsibilityGetTransferCenterOptions(param).then((res) => {
        if (res.code === 200) {
          this.transitCenterOptions = (res.data || []).map((item) => {
            return {
              value: item.name,
              label: item.name
            };
          });
        }
      });
    },
    // 获取客户
    getCustomerPage(name = '') {
      const param = {
        pageSize: 20,
        pageNumber: 1,
        params: {
          quickSearch: name
        }
      };
      apiGetCustomerPage(param).then((res) => {
        if (res.code === 200) {
          this.customerList = res.data.records;
        }
      });
    }
  }
};
</script>

<style>
.SelectV2_popper {
  width: 170px;
}
</style>
<style lang="scss" scoped>
.update_time_class {
  text-align: right;
  font-size: 12px;
  line-height: 13px;
  margin: 10px 0 5px;
}
.c1.box-card-class ::v-deep .el-card__body {padding-bottom: 0 !important;}
.box {
  width: 100%;height: 100%;background: #f1f5f9;
  position: absolute;top: 0; left: 0;
  overflow-y: auto;
  padding: 10px;box-sizing: border-box;
}
.box-card-class {
  border-radius: 10px;box-sizing: border-box;
  margin-bottom: 10px;
}
.dateClass {
  width: 220px;margin-top: 5px;border-radius: 10px !important;
  display: inline-flex;justify-content: space-between;align-items: center;
}
.dateClass ::v-deep .el-range__close-icon, .dateClass ::v-deep .el-range__icon {
  display: none;
}

.custom-radio-group ::v-deep .el-radio-button:first-child .el-radio-button__inner {
  border-radius: 10px 0 0 10px !important;
}
.custom-radio-group ::v-deep .el-radio-button:last-child .el-radio-button__inner {
  border-radius: 0 10px 10px 0 !important;
}
.custom-radio-group ::v-deep .el-radio-button:not(:first-child):not(:last-child) .el-radio-button__inner {
  border-radius: 0 !important;
}

.regionSteteClass {
  display: flex;justify-content: space-between;align-items: center;
  border: 1px solid #E6EAED; border-radius: 10px;padding: 5px 10px;box-sizing: border-box;
  .searchClass {
    font-size: 12px;text-align: left;margin-top: 4px;
  }
  .searchBtn {
    display: flex;justify-content: center;align-items: center;
    width: 33px !important;height: 33px !important;font-size: 18px;color: #fff;background-color: #00A551;border-radius: 10px;
    flex-shrink: 0; // 防止按钮在 flex 布局中被压缩，保持固定的 33px 宽度
  }
  .dividerClass {
    border-right: 1px solid #E6EAED;box-sizing: border-box;margin-right: 10px;
  }
}
.regionSteteClass ::v-deep .el-select, .regionSteteClass ::v-deep .el-select .el-input__inner {
  text-align: left;border: none;padding-left: 0 !important;
}
.regionSteteClass ::v-deep .el-select .el-input__inner {
  height: 21px;line-height: 21px;
}
.box-card-class.c2 ::v-deep .el-card__body {
  padding: 0 20px;box-sizing: border-box;
}
.box-card-class.c2 ::v-deep .el-tabs__nav-scroll {
  display: flex;justify-content: center;align-items: center;
}
.box-card-class.c2 ::v-deep .el-tabs__nav-wrap::after {
  background-color: transparent !important;
}
.box-card-class.c2 ::v-deep .el-tabs__header {margin: 0 !important;}
.box-card-class.c2 ::v-deep .el-tabs__active-bar {display: none;} // 选中项的下划线隐藏
.box-card-class.c2 ::v-deep .el-tabs__item.is-active {
  color: #0F1728 !important; font-weight: bold;
}
.box-card-class.c2 ::v-deep .el-tabs__item.is-active::after {
  content: none;
}
.box-card-class.c2 ::v-deep .el-tabs__item {
  color: #6A7382 !important;
}

.redClass{
  display: inline-block;position: relative;padding-left: 10px;
  margin-right: 10px;
}
.redClass::before {
  position: absolute;margin-left: -10px;content: '*';color: #F56C6C;
}
.card-title-class {
  font-size: 15px;color: #000;font-weight: bold;
}
.last.card-title-class {
  margin-left: 0 !important;
}
.box-card-class .card-title-class {
  margin-left: 20px;
}
.box-card-class.c4 ::v-deep .el-card__body {
  padding-left: 0!important;padding-right: 0!important;
}
.data-monitoring-container {
  margin-top: 10px;padding: 0 20px;box-sizing: border-box;
  .data-card-wrapper {
    display: flex;gap: 10px;margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
.data-card {
  flex: 1;padding: 20px;
  box-sizing: border-box;background: #F9F9F9;border-radius: 10px;position: relative;
}
.data-label {
  font-size: 14px;color: #6A7382;text-align: left;position: relative;z-index: 3;
  margin-right: 20px;margin-bottom: 8px;
}
.data-value {
  font-size: 24px;color: #0F1728;font-weight: bold;text-align: left;
}
.corner-decoration {
  position: absolute;
  top: 0;
  right: 0;
  width: 60px;
  height: 60px;

  .corner-rectangle {
    position: absolute;
    top: 0;
    right: 0;
    width: 70px;
    height: 35px;

    &.style-1 {
      border-radius: 0px 12px 0px 160px;
      background-color: #FEFBEA;
    }
    &.style-2 {
      border-radius: 0px 12px 0px 160px;
      background-color: #EFF6FF;
    }
    &.style-3 {
      border-radius: 0px 12px 0px 160px;
      background-color: #FEF2F2;
    }
    &.style-4 {
      border-radius: 0px 12px 0px 160px;
      background-color: #FEFBEA;
    }
    &.style-5 {
      border-radius: 0px 12px 0px 160px;
      background-color: #EFF6FF;
    }
    &.style-6 {
      border-radius: 0px 12px 0px 160px;
      background-color: #FEF2F2;
    }
    &.style-11 {
      border-radius: 0px 12px 0px 160px;
      background-color: #EBFDF6;
    }
  }

  .corner-square {
    position: absolute;top: 16px;right: 17px;
    width: 27px;height: 27px;border-radius: 6px;

    &.style-1 {
      background-color: #FDF2C5;
    }
    &.style-2 {
      background-color: #DBEAFE;
    }
    &.style-3 {
      background-color: #FEE1E1;
    }
    &.style-4 {
      background-color: #FDF2C5;
    }
    &.style-5 {
      background-color: #DBEAFE;
    }
    &.style-6 {
      background-color: #FEE1E1;
    }
    &.style-22 {
      background-color: #CDFBE4;

    }
  }

  .corner-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    font-size: 14px;
    transform: translate(-50%, -50%);

    &.style-1 {
      color: #fbbf23;
    }
    &.style-2 {
      color: #3e5dac;
    }
    &.style-3 {
      color: #b74545;
    }
    &.style-4 {
      color: #fbbf23;
    }
    &.style-5 {
      color: #3e5dac;
    }
    &.style-6 {
      color: #b74545;
    }
    &.style-33 {
      color: #0f9268;
    }
    &.style-44 {
      color: #0f9268;
      &::after {
        content: '%';
        position: absolute;
        top: 47%;
        left: 40%;
        transform: translate(-50%, -50%);
        font-size: 5px;
        font-weight: bold;
        color: inherit;
      }
    }
  }
}

.arrival-monitoring-content {
  margin-top: 15px;
  .info-section {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    .info-label.left {color: #3E5DAC;}
    .info-label.right {color: #0F9268;}
    .info-label {
      font-size: 30px;
      font-weight: bold;
    }
    .info-detail {
      margin-left: 20px;
      text-align: left;
      color: #0F1728;
      font-size: 16px;
      font-weight: bold;
      span {
        line-height: 1.5;
      }
    }
  }
  .arrival-table ::v-deep .el-table__body tr td:last-child {
    color: #B74545;
  }
}

.uploadClass {
  position: absolute;right: 16px;top: 1px;
  width: 25px;height: 25px;
  text-align: center;
  font-size: 20px;line-height: 24px;cursor: pointer;
}
.u3.uploadClass, .u4.uploadClass {
  top: 20px;
}
</style>
